import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/components/atoms/Toast';
import { createSandboxPrompt } from '@/services/sandboxPromptsService';
import type { HttpResponseError } from '@/services/service';
import type { SandboxPromptSchemaProps } from '@/schemas/sandboxPrompts/schema';

type UseCreateSandboxPromptMutationProps = {
	onSuccess: () => void;
};

export const useCreateSandboxPromptMutation = ({
	onSuccess
}: UseCreateSandboxPromptMutationProps) => {
	const { toast } = useToast();

	const queryClient = useQueryClient();

	return useMutation<unknown, HttpResponseError, SandboxPromptSchemaProps>({
		mutationKey: ['sandbox-prompt-create-mutation'],
		mutationFn: createSandboxPrompt,
		onSuccess: () => {
			queryClient.invalidateQueries(['sandbox-prompt-query']);
			onSuccess();
		},
		onError: error => {
			// eslint-disable-next-line no-console
			console.error({ error });

			const errorMessage = {
				title: 'Something unexpected happened',
				description: 'Please try again or contact the support'
			};

			toast({
				...errorMessage,
				variant: 'error'
			});
		}
	});
};
